export default {
	facebookUrl: 'https://www.facebook.com/Apartment-Doctor-cz-105401644770914/?view_public_for=105401644770914',
	instagramUrl: 'https://www.instagram.com/apartment_doctor/',
};
